import {API_ROLE_LEVEL, API_ROLE_LEVEL_BY_ID, API_ROLE_LEVEL_BY_PRACTICE} from "../../const/Api";
import {RestApiMethod} from "../../const/dataEnum";
import {callAPI} from "./callApi";

const getAll = async () => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: API_ROLE_LEVEL,
    });
    return res.data;
  } catch (error) {
    console.error('roleLevelApi getAll Error:', error.message);
    return null;
  }
};

const getRoleLevelById = async (roleLevelId) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: API_ROLE_LEVEL_BY_ID.replace("{ROLE_LEVEL_ID}", roleLevelId),
    });
    return res.data;
  } catch (error) {
    console.error('roleLevelApi getRoleLevelById Error:', error.message);
    return null;
  }
};

const getRoleLevelByPracticeId = async (practiceId) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: API_ROLE_LEVEL_BY_PRACTICE.replace("{PRACTICE_ID}", practiceId),
    });
    console.log(res.data);
    return res.data;
  } catch (error) {
    console.error('roleLevelApi getRoleLevelByPracticeId Error:', error.message);
    return null;
  }
};

const roleLevelApi = {
  getAll,
  getRoleLevelById,
  getRoleLevelByPracticeId
}

export default roleLevelApi;